export const GUAYAKI_ORG_ID = "01926e1a-7e9b-6ddb-7e27-46f8243bd10b"
